<template>
    <div class="app-layout" ref="layout" @scroll="scroll">
        <!-- 头部导航 -->
        <header class="app-layout__header">
            <div class="app-layout__header-nav">
                <header-nav></header-nav>
            </div>
        </header>
        <!-- 中间内容 -->
        <main class="app-layout__main" :class="{ 'app-layout__no-footer': noFooter }">
            <div :class="{ 'main-content': !notCenterLayout }">
                <router-view v-if="isRouterAlive"></router-view>
            </div>
        </main>
        <!-- 底部信息 -->
        <footer class="app-layout__footer" v-if="!noFooter">
            <div class="app-layout__footer-wrapper">
                <div class="footer-content">
                    <ul class="footer-content__about">
                        <router-link tag="li" to="/blackboard/aboutUs">关于我们</router-link>
                        <router-link tag="li" to="/blackboard/copyright">版权声明</router-link>
                        <router-link tag="li" to="/blackboard/helpCenter">帮助中心</router-link>
                        <router-link tag="li" to="/blackboard/contract">业务合作</router-link>
                        <router-link tag="li" to="/blackboard/advertise">广告投放</router-link>
                    </ul>
                </div>
                <div class="footer-QRcode" v-if="QRcode">
                    <img :src="QRcode" alt="">
                </div>
                <span class="footer-content__copyright">
                    Copyright &copy; 2019-现在 数字像素 版权所有&nbsp;
                    <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备19027367号-5</a>
                    <img src="../../assets/images/police.png" alt="">
                    <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502008154" target="_blank">川公网安备51019002005714</a>
                </span>

            </div>
        </footer>

        <el-backtop ref="backTop" target=".app-layout" :visibility-height="400" :bottom="160"></el-backtop>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getToken } from '@/utils/auth';
import { getFootByType } from '@/api/blackboard';
import HeaderNav from './Nav';

export default {
    name: 'Layout',
    provide() {
        return {
            reload: this.reload,
            backTop: this.backTop,
            checkToken: this.checkToken,
            interceptLeave: this.interceptLeave
        };
    },
    components: {
        HeaderNav
    },
    data: () => ({
        isRouterAlive: true,
        QRcode: null,
        notCenterLayout: false,
        noFooter: false,
    }),
    watch: {
        '$route': function(val) {
            const { notCenterLayout, noFooter } = val.meta;
            this.notCenterLayout = notCenterLayout;
            this.noFooter = noFooter;
            this.backTop();
        }
    },
    mounted() {
        const { notCenterLayout, noFooter } = this.$route.meta;
        this.notCenterLayout = notCenterLayout;
        this.noFooter = noFooter;
        getFootByType({ type: 5 }).then(({ code, data }) => {
            if (code === 0) {
                this.QRcode = data;
            }
        });
    },
    methods: {
        ...mapActions('login', ['OpenDialog']),
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },
        checkToken() {
            if (getToken()) {
                return true;
            } else {
                this.$message.error('请先登录');
                this.OpenDialog(0);
            }
        },
        // 拦截路由离开状态
        interceptLeave(e, isWarning) {
            if (isWarning) {
                e = e || window.event;
                if (e) {
                    e.returnValue = "您是否确认离开此页面-您输入的数据可能不会被保存";
                }
                return "您是否确认离开此页面-您输入的数据可能不会被保存";
            } 
            
            return '';
        },
        backTop() {
            this.$refs.backTop.handleClick();
        },
        scroll() {
            const scrollTop = this.$refs.layout.scrollTop;
            const windowHeight = this.$refs.layout.clientHeight;
            const scrollHeight = this.$refs.layout.scrollHeight;
            if (scrollHeight - (scrollTop + windowHeight) < 100) {
                // console.log('滚动条到底部了');
                this.$store.dispatch('app/changeScrollStatus', new Date());
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.app-layout {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    &__header {
        height: 72px;
        min-width: 1600px;
        background: linear-gradient(270deg, #020322 0%,#060932  100%);

        &-nav {
            margin: 0 auto;
            width: 1600px;
        }
    }

    &__main {
        min-height: calc(100% - 72px - 151px);
        background: rgba(245, 246, 249, 1);
        min-width: 1600px;

        .main-content {
            margin: 0 auto;
            padding: 30px 0;
            width: 1600px;
            background: rgba(245, 246, 249, 1);
        }
    }
    &__no-footer {
        min-height: calc(100% - 72px);
    }

    &__footer {
        color: rgba(145, 145, 145, 1);
        font-size: 12px;
        background: linear-gradient(270deg, #020322 0%, #060932 100%);
        padding: 10px 0;
        border-top: 1px solid rgba(224, 228, 247, 1);
        overflow: hidden;

        &-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 1600px;
            padding: 22px 0;
            margin: 0 auto;

            .footer-content {
                @include font(rgba(191, 191, 191, 1), 12px, 400);
                &__about {
                    display: flex;
                    margin-top: 15px;
                    margin-bottom: 20px;
                    align-items: center;

                    li {
                        cursor: pointer;
                        width: 130px;
                        border-right: 1px solid #D7D7D7;
                        height: 10px;
                        font-size: 12px;
                        color:#BFBFBF;
                        overflow: visible;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:nth-last-child(1) {
                            border-right: 0;
                        }
                    }
                }

            }

            .footer-QRcode {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;

                img {
                    width: 70px;
                    height: 70px;
                }

            }
              .footer-content__copyright {
                        color: #BFBFBF;
                        font-size: 12px;
                        display: flex;
                        align-content: center;
                        justify-content: center;
                        a{
                            color: #BFBFBF;
                        }
                        img {
                            width: 15px;
                            height: 15px;
                            margin: 0 4px;
                        }
                }
        }
    }
}

// 小屏
@include mq($small) {
    .app-layout {
        &__header {
            min-width: 1200px;
            &-nav {
                width: 1200px;
            }
        }

        &__main {
            min-width: 1200px;
            .main-content {
                padding: 22px 0;
                width: 1200px;
            }
        }

        &__footer {
            min-width: 1200px;
            &-wrapper {
                width: 1200px;
            }
        }
    }
}
// 小屏
@include mq($smaller) {
    .app-layout {
        &__header {
            min-width: unset;
            &-nav {
                width: unset;
            }
        }

        &__main {
            min-width: unset;
            .main-content {
                padding: 22px;
                width: unset;
            }
        }

        &__footer {
            min-width: unset;
            &-wrapper {
                width: unset;
            }
        }
    }
}
</style>
